/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/anchor-is-valid */
import { Section, useCitiesContext } from '@spotahome/ui-library';
import { getPagePath, trans } from '@spotahome/soyuz/client';

import withInViewEvent from '@spotahome/ui-library/src/tenant/components/withInViewEvent';
import useHorizontalDrag from '@spotahome/ui-library/src/hooks/useHorizontalDrag';

import {
  LANDING_SECTIONS,
  TOP_CITIES,
  SEO_LINK_CITIES_KEYS
} from '@spotahome/ui-library/src/tenant/components/utils/seoConstants';
import CityList from '@spotahome/ui-library/src/tenant/components/CityList';

import City from './City';

// styles
import './CitiesShowcase.scss';

const COUNTRY_PAGES = {
  FR: 'external.country.page.france',
  ES: 'external.country.page.spain',
  IT: 'external.country.page.italy',
  DE: 'external.country.page.germany',
  PT: 'external.country.page.portugal',
  GB: 'external.country.page.united-kingdom'
};

const getCountryPageUrl = countryIsoCode =>
  COUNTRY_PAGES[countryIsoCode]
    ? getPagePath(COUNTRY_PAGES[countryIsoCode])
    : null;

const CitiesShowcase = () => {
  const { cities } = useCitiesContext();
  const {
    containerRef,
    isDragging,
    handleMouseDown,
    handleMouseUp,
    handleTouchStart,
    handleTouchEnd
  } = useHorizontalDrag({
    onMoveStart: () => {},
    onMove: () => {}
  });
  const topCitiesKeys = Object.keys(TOP_CITIES);
  const carouselCities = topCitiesKeys
    .map(key => cities.find(city => city.id === key))
    .filter(Boolean);

  const listCities = cities
    .filter(
      city =>
        !topCitiesKeys.includes(city.id) &&
        SEO_LINK_CITIES_KEYS.includes(city.id)
    )
    .sort((a, b) => a.cityName.localeCompare(b.cityName));

  const handleCityClick = cityId => e => {
    e.preventDefault();
    e.stopPropagation();
    if (isDragging()) {
      return;
    }

    const path = getPagePath('marketplace.free-search', {
      params: { locationString: cityId }
    });

    window.location.href = path;
  };

  const handleCountryClick = countryIsoCode => e => {
    e.preventDefault();
    e.stopPropagation();
    if (isDragging()) {
      return;
    }

    const path = getCountryPageUrl(countryIsoCode);

    window.location.href = path;
  };

  return (
    <Section background="light" className="cities-showcase__container">
      <Section background="light" className="cities-showcase__top-cities">
        <div className="cities-showcase">
          <div className="cities-showcase__header">
            <h2 className="cities-showcase__header-title">
              {trans('landingpage.label.cities')}
            </h2>
          </div>
          <ul
            className="cities-showcase__carousel-list"
            onMouseDown={handleMouseDown}
            onMouseUp={handleMouseUp}
            onTouchStart={handleTouchStart}
            onTouchEnd={handleTouchEnd}
            ref={containerRef}
          >
            {carouselCities.map(city => (
              <li key={city.id} className="cities-showcase__carousel-item">
                <City
                  id={city.id}
                  countryId={city.country.countryId.toLowerCase()}
                  countryPageUrl={getCountryPageUrl(
                    city.country.countryIsoCode
                  )}
                  onClick={handleCityClick(city.id)}
                  onCountryClick={handleCountryClick(
                    city.country.countryIsoCode
                  )}
                />
              </li>
            ))}
          </ul>
        </div>
      </Section>
      <Section background="light" className="cities-showcase__other-cities">
        <CityList cities={listCities} />
      </Section>
    </Section>
  );
};

export default withInViewEvent(LANDING_SECTIONS.citiesShowcase)(CitiesShowcase);
